module.exports = __webpack_public_path__ + "static/media/simplonoi-headline-webfont.815fc436.ttf";